'use client';
import { Conditional } from '@cat-ecom/pcc-components';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
import { B2C_LOGIN_URL } from 'constants/links';
import { useTranslations } from 'next-intl';
import { useParams, usePathname } from 'next/navigation';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';
import cx from 'classnames';
import { FixedContainer } from 'app/[lang]/[esite]/(core)/product/[product]/fixed-container';
import { ButtonSize } from '@blocks-web-components/components/button/button.model';
import { Variant } from 'components/contact-your-dealer/types';

type CheckPriceActionsProps = {
  isStickyCTAMobileFlag?: boolean;
  buttonSize?: ButtonSize;
  marginTopClassName?: string;
  variant?: Variant;
  hideLogin?: boolean;
};

const CheckPriceActions = ({
  isStickyCTAMobileFlag,
  buttonSize,
  marginTopClassName = 'cat-u-margin-top-sm',
  variant,
  hideLogin
}: CheckPriceActionsProps) => {
  const t = useTranslations();
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();
  const esiteUrl = getSeoUrl(params);

  /*
    TODO - Input Validations - usePathName: string except the
    generalRestrictedCharacters (@\constants\securityConstants.ts)
  */
  const pathname = usePathname();
  const isHomePage = esiteUrl === pathname;
  const dealerLocatorDrawer = useDealerLocatorDrawer();

  const loginUrl = normalizeCommerceLink(
    getSeoUrl(params, B2C_LOGIN_URL, {
      pageRedirectUrl: pathname,
      loginFromHomePage: isHomePage
    })
  );
  const openDealerLocatorDrawer = () => dealerLocatorDrawer.openDrawer();

  const getButton = (size: ButtonSize) => (
    <CatButton
      size={size}
      variant={variant}
      onClick={() => dealerLocatorDrawer.openDrawer()}
    >
      {t('CAT_CHECK_PRICE')}
    </CatButton>
  );

  return (
    <>
      <div className={cx('row align-items-center', marginTopClassName)}>
        <div
          data-testid="check-price-div"
          className={cx('col-12 col-md-auto pe-lg-0', {
            'd-none d-md-block d-lg-none': isStickyCTAMobileFlag,
            'd-lg-none d-md-block': !isStickyCTAMobileFlag
          })}
        >
          {getButton('sm')}
        </div>
        <div className={cx('col-12 col-md-auto pe-lg-0 d-lg-block d-none')}>
          {getButton(buttonSize ?? 'lg')}
        </div>
        {!hideLogin && (
          <div className="col-12 col-md cat-u-display-flex justify-content-start px-0 py-0">
            <CatButton variant="ghost" href={loginUrl}>
              {t('CAT_VIEW_CUSTOMER_PRICE')}
            </CatButton>
          </div>
        )}
      </div>
      <Conditional test={isStickyCTAMobileFlag}>
        <FixedContainer
          spacerClassName="d-md-none"
          containerClassName="d-md-none"
        >
          <CatButton
            size="md"
            fullWidth
            variant="contrast"
            onClick={openDealerLocatorDrawer}
          >
            {t('CAT_CHECK_PRICE')}
          </CatButton>
        </FixedContainer>
      </Conditional>
    </>
  );
};

export default CheckPriceActions;
